import { mmFetch } from './mmFetch';
import { mmFetchWithResponse } from './mmFetchWithResponse';

const trainingApi = {
    getAllTrainingScenarios: async (facilityID) => {
        const url = `api/warehouse/v1/training?facilityID=${facilityID}`;
        return mmFetchWithResponse(url);
    },
    getTrainingLPN: async (id) => {
        const url = `api/warehouse/v1/training/lpn/${id}`;
        try {
            const response = await mmFetch(url);
            if (response.ok === true) {
                const blob = await response.blob();
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob);
                    return;
                }

                const d = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                document.body.appendChild(link);
                link.href = d;
                link.download = `training-${id}.pdf`;
                link.click();

                setTimeout(() => {
                    if (window.URL && typeof window.URL.revokeObjectURL === 'function') {
                        window.URL.revokeObjectURL(response);
                    }
                }, 200);
            }
            return response.ok;
        } catch (e) {
            console.log('[downloadPDF] error', e.toString());
        }
    },
};

export { trainingApi };
